
import { Movie } from "@/types/movie";
import { useFavoriteCommit } from "./useFavoriteCommit";
import { usePlanToWatchCommit } from "./usePlanToWatchCommit";

/**
 * Hook for immediate commit operations using universal metadata service
 * UPDATED: Uses CommitToggleService with universal metadata architecture
 */
export const useCommitToggle = (
  allMovies: Movie[],
  addMovie: (movie: Movie) => void,
  updateMovieState: (tmdbId: number, props: Partial<Movie>) => void,
  getVisualState: (tmdbId: number, propertyName: 'favorite' | 'planToWatch') => { isPending: boolean; isOptimistic: boolean; currentValue: boolean }
) => {
  
  const { commitToggleFavorite } = useFavoriteCommit(
    allMovies,
    addMovie,
    updateMovieState,
    getVisualState
  );

  const { commitTogglePlanToWatch } = usePlanToWatchCommit(
    allMovies,
    addMovie,
    updateMovieState,
    getVisualState
  );

  return {
    commitToggleFavorite,
    commitTogglePlanToWatch
  };
};
